export const SUCCESS = "SUCCESS"
export const ERROR = "ERROR"
const ROLE_VAN_THU_TRUONG = "9997"
const ROLE_TRUONG_PHONG_HANH_CHINH = "9998"
const ROLE_XEM_TAT_CA_VAN_BAN_DEN = "9090";
const ROLE_GIAO_VU_KHOA = "12121";
const ROLE_TRUONG_PHONG_PHAP_CHE = "28923";
const CAP_NHAT_THONG_TIN_LIEN_LAC = "capnhatthongtinlienlac";

export const CONSTANTS = {
    SUCCESS, ERROR, ROLE_VAN_THU_TRUONG, ROLE_TRUONG_PHONG_HANH_CHINH,ROLE_XEM_TAT_CA_VAN_BAN_DEN, ROLE_GIAO_VU_KHOA, CAP_NHAT_THONG_TIN_LIEN_LAC, ROLE_TRUONG_PHONG_PHAP_CHE
}
